import React, { useEffect } from "react";
import styled from "@emotion/styled";
import moment from "moment";
import { Form, Input, Select, Button, DatePicker } from "antd";
import { css } from "@emotion/react";

import { useNavigate } from "react-router-dom";
import { responsive } from "../../utils/style";
import InfoIcon from "../../assets/icons/Info-icon.svg";
import InfoWhite from "../../assets/icons/info-white.svg";
import Api from "../../utils/api";
import {
  FieldContainer,
  CustomSelect,
  Option,
  DateField,
} from "../../components/CustomFields";

import DetailImageModal from "../../components/Modal/DetailImageModal";

import CompleteIcon from "../../assets/images/completed_status.svg";

moment.locale("th");

const disabledDate = (current) => {
  if (current && moment(current).day() !== 1) return true;
  return current && current < moment().endOf("day");
};

export const RegisterForm = (props) => {
  const { school, role, setEmail } = props;
  console.log(school, role);
  const [form] = Form.useForm();
  const [schoolOptions, setSchoolOptions] = React.useState([]);
  const [modalVisible, setModalVisible] = React.useState(false);

  const navigate = useNavigate();

  console.log(school);

  const schoolClassrooms = Array(school?.roomUnit)
    .fill(null)
    .map((_, i) => i + 1);
  const schoolLevels = [1, 2, 3, 4, 5, 6];

  useEffect(() => {
    const getSchoolChoice = async () => {
      await Api.get("schools/masterData")
        .then((res) => {
          setSchoolOptions(res.data.schoolMasters);
        })
        .catch((err) => {
          alert(err.response.data.message);
        });
    };

    getSchoolChoice();

    form.setFieldsValue({
      matchName: "เกมเณรกล้า โภชนาดี ครั้งที่ 1",
    });
  }, []);

  const onFinish = async (values) => {
    values.role = role;
    let registerUrl = "";

    if (role === "student") {
      registerUrl = "authen/studentRegister";
      values.secretCode = school?.studentSecretCode;
    } else if (school) {
      registerUrl = "authen/staffRegister";
      values.secretCode = school?.staffSecretCode;
    } else {
      registerUrl = "authen/adminRegister";
    }
    await Api.post(registerUrl, values)
      .then((res) => {
        if (res.data.message === "success") {
          setModalVisible(true);
        }
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  return (
    <FormContainer>
      <Form
        layout="vertical"
        form={form}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
        style={{ width: "100%" }}
        size="large"
      >
        {!school && (
          <>
            <FieldContainer
              name="schoolName"
              label="ระบุชื่อกลุ่ม"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุชื่อกลุ่ม!",
                  whitespace: true,
                },
              ]}
              marginBottom={0}
            >
              <div>
                <Input placeholder="โปรดระบุ" />

                <NameInfoLabel>
                  <Icon src={InfoIcon} />
                  ไม่แนะนำให้ใช้ชื่อโรงเรียน และตั้งชื่อให้จดจำได้ง่ายตัวอย่าง :
                  เฮลท์ฮีโร่
                </NameInfoLabel>
              </div>
            </FieldContainer>
            <FieldContainer
              name="studentSecretCode"
              label="โค้ด สำหรับสามเณร"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุโค้ด สำหรับสามเณร!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("staffSecretCode") !== value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "โค้ดสำหรับสามเณร ไม่ควรซ้ำกับโค้ดสำหรับพระสงฆ์ ครูฆราวาส!"
                      )
                    );
                  },
                }),
              ]}
              marginBottom={0}
            >
              <div>
                <Input placeholder="โปรดระบุ" />

                <NameInfoLabel>
                  <Icon src={InfoIcon} />
                  ตั้งให้จดจำได้ง่าย
                </NameInfoLabel>
              </div>
            </FieldContainer>
            <FieldContainer
              name="staffSecretCode"
              label="โค้ด สำหรับพระสงฆ์ ครูฆราวาส"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุโค้ด สำหรับพระสงฆ์ ครูฆราวาส!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (
                      !value ||
                      getFieldValue("studentSecretCode") !== value
                    ) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "โค้ดสำหรับสามเณร ไม่ควรซ้ำกับโค้ดสำหรับพระสงฆ์ ครูฆราวาส!"
                      )
                    );
                  },
                }),
              ]}
              marginBottom={0}
            >
              <div>
                <Input placeholder="โปรดระบุ" />
              </div>
            </FieldContainer>
          </>
        )}

        {school && <SchoolName>{school?.schoolName}</SchoolName>}
        <FieldContainer
          name="firstname"
          label="ชื่อ"
          rules={[
            {
              required: true,
              message: "โปรดระบุชื่อ!",
              whitespace: true,
            },
          ]}
          marginBottom={0}
        >
          <div>
            <Input placeholder="โปรดระบุ" />

            <NameInfoLabel>
              <Icon src={InfoIcon} />
              ใช้ชื่อจริง แต่ไม่ระบุนามสกุล
            </NameInfoLabel>
          </div>
        </FieldContainer>
        {role === "student" && (
          <>
            <FieldContainer
              name="nickname"
              label="ชื่อเล่น"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุชื่อเล่น!",
                  whitespace: true,
                },
              ]}
              marginBottom={0}
            >
              <Input placeholder="โปรดระบุ" />
            </FieldContainer>

            <FieldContainer
              name="classNo"
              label="กำลังศึกษาในระดับชั้น "
              className="selector-field"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุระดับชั้น!",
                },
              ]}
              marginBottom={0}
            >
              <CustomSelect placeholder="โปรดระบุ" width="100%" widthRs="100%">
                {schoolLevels.map((value, i) => (
                  <Option key={i} value={value}>
                    ม.{value}
                  </Option>
                ))}
              </CustomSelect>
            </FieldContainer>

            <FieldContainer
              name="roomNo"
              label="ห้อง "
              className="selector-field"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุห้อง!",
                },
              ]}
              marginBottom={0}
            >
              <CustomSelect placeholder="โปรดระบุ" width="100%" widthRs="100%">
                {schoolClassrooms.map((value, i) => (
                  <Option key={i} value={value}>
                    {value}
                  </Option>
                ))}
              </CustomSelect>
            </FieldContainer>
          </>
        )}

        <FieldContainer
          name="username"
          label="ชื่อผู้ใช้งาน (USERNAME)"
          rules={[
            {
              required: true,
              message: "โปรดระบุ Username!",
            },
          ]}
          marginBottom={0}
        >
          <Input placeholder="โปรดระบุ" />
        </FieldContainer>
        <PasswordReccommend>
          <Center>
            <Icon src={InfoWhite} />
            ใช้ภาษาอังกฤษโดยตั้งให้จดจำได้ง่าย
          </Center>
        </PasswordReccommend>
        <FieldContainer
          name="password"
          label="รหัสผ่าน"
          rules={[
            {
              required: true,
              message: "โปรดระบุรหัสผ่าน!",
            },
            {
              pattern: /^[a-zA-Z\d]+$$/,
              message: `
              ประกอบด้วยตัวเลข (0-9) หรือตัวอักษรภาษาอังกฤษ(a-z)`,
            },
            { min: 8, message: "ต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร" },
          ]}
          hasFeedback
          marginBottom={0}
        >
          <Input.Password placeholder="โปรดระบุ" />
        </FieldContainer>

        <FieldContainer
          name="confirm"
          label="ยืนยันรหัสผ่าน"
          dependencies={["password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: "โปรดยืนยันรหัสผ่าน!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }

                return Promise.reject(new Error("รหัสผ่านไม่ตรงกัน!"));
              },
            }),
          ]}
          marginBottom={0}
        >
          <Input.Password placeholder="โปรดระบุ" />
        </FieldContainer>

        <PasswordReccommend>
          คำแนะนำการตั้งรหัสผ่าน คำแนะนำการตั้งรหัสผ่าน
          <ul>
            <li>ต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร</li>
            <li>ประกอบด้วยตัวเลข (0-9) หรือตัวอักษรภาษา อังกฤษ(a-z)</li>
            <li>โปรดตั้งรหัสผ่านที่จดจำได้ง่าย</li>
          </ul>
        </PasswordReccommend>

        {!school && (
          <>
            <FieldContainer
              name="roomUnit"
              label="จำนวนห้องเรียนสูงสุดของชั้นเรียนทั้งหมด"
              // tooltip="What do you want others to call you?"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุจำนวนห้องเรียน!",
                  whitespace: true,
                },
              ]}
              marginBottom={0}
            >
              <Input type="number" placeholder="โปรดระบุ" />
            </FieldContainer>
            <FieldContainer
              name="maxWeek"
              label="จำนวนสัปดาห์ที่แข่งขัน"
              // tooltip="What do you want others to call you?"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุจำนวนสัปดาห์ที่แข่งขัน!",
                },
              ]}
              marginBottom={0}
            >
              <CustomSelect
                width="100%"
                widthRs="100%"
                type="number"
                placeholder="โปรดระบุ"
                marginBottom={0}
              >
                {new Array(4).fill(0).map((_, week) => (
                  <Option value={(week + 1) * 4}>{(week + 1) * 4}</Option>
                ))}
              </CustomSelect>
            </FieldContainer>
            <FieldContainer
              name="matchName"
              label="ชื่อกิจกรรมในการแข่งขัน"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุชื่อกิจกรรม!",
                  whitespace: true,
                },
              ]}
              marginBottom={0}
              extra={
                <NameInfoLabel>
                  <Icon src={InfoIcon} />
                  สามารถแก้ไขได้
                </NameInfoLabel>
              }
            >
              <Input placeholder="โปรดระบุ" />
            </FieldContainer>
            <DateField
              name="startDate"
              label="วันเริ่มต้นของการแข่งขัน"
              rules={[
                {
                  required: true,
                  message: "โปรดระบุวันเริ่มต้น!",
                },
              ]}
              marginBottom={0}
            >
              <DatePicker placeholder="โปรดระบุ" disabledDate={disabledDate} />
            </DateField>
          </>
        )}

        <FieldContainer shouldUpdate>
          {() => (
            <Button
              type="primary"
              htmlType="submit"
              disabled={
                !!form.getFieldsError().filter(({ errors }) => errors.length)
                  .length
              }
            >
              ลงทะเบียน
            </Button>
          )}
        </FieldContainer>
      </Form>
      <DetailImageModal
        visible={modalVisible}
        onClose={() => navigate("/login")}
        img={CompleteIcon}
        topic="ลงทะเบียนสำเร็จ"
        remark="คุณสามารถเข้าใช้งานได้ทันที"
        imageWidth={144}
      />
    </FormContainer>
  );
};

const SchoolName = styled.div`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 23px;
  /* identical to box height, or 110% */

  letter-spacing: -0.02em;

  /* Primary/Green 500 */

  color: #058459;
  text-align: center;
  margin-bottom: 16px;
`;

const GenerateInfo = styled.div`
  display: flex;
  justify-content: center;
  font-family: "Noto Sans Thai", "Noto Sans";
  margin: auto;
  gap: 8px;
  margin-top: 16px;
  span {
    font-family: "Noto Sans Thai", "Noto Sans";
    margin: auto;
    line-height: 2px;
  }
`;

const RegisterButton = styled.button`
  border-radius: 100px;
  width: 206px;
  height: 51px;
  border: 0;
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  background-color: ${(props) => (props.active ? "#16AF7B" : "#D0D5DD")};
  color: ${(props) => (props.active ? "#FFFFFF" : "#64748B")};
  align-items: center;
  margin: auto;
  justify-content: center;
  display: flex;
`;

const PasswordReccommend = styled.div`
  background: #323a46;
  border-radius: 8px;
  padding: 10px !important;
  width: 308px;
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #fcfcfc;
  margin: 16px auto;

  ul {
    padding-left: 25px;
  }
`;

const FormContainer = styled.div`
  margin: 40px 0 0 0;
  width: 70%;
  ${responsive.mobile(css`
    width: 90%;
  `)}

  label {
    font-family: "Noto Sans Thai", "Noto Sans";
    font-style: normal;
    font-weight: 500;
    color: #4b5768;
    font-size: 21px;
    height: auto !important;
  }

  div {
    padding-bottom: 0;
  }

  span {
    text-align: left;
    font-family: "Noto Sans Thai", "Noto Sans";
    // color: rgba(0, 0, 0, 0.25);
  }

  input {
    box-sizing: border-box;
    border-radius: 4px;
    height: 52px;
    border: 1px solid #a0abbb;
    font-family: "Noto Sans Thai", "Noto Sans";

    &[type="password"] {
      height: 38px;
      border: none;
    }
  }

  input::placeholder {
    font-family: "Noto Sans Thai", "Noto Sans";
  }

  form > div:not(.selector-field) {
    margin-bottom: 24px;
  }
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.img`
  margin-right: 10px;
`;

const NameInfoLabel = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 32px;

  text-align: center;

  color: #4b5768;

  margin-top: 4px;
`;
